import axios from "axios";
export default {
    getUserStatusDictionary: () => axios.post("/Users/GetUserStatusDictionary", {}),
    getSelf: () => axios.post("/Users/GetSelf", {}),
    getUsers: () => axios.post("/Users/GetUsers", {}),
    blockUsers: (ids) => axios.post("/Users/BlockUsers", { ids }),
    unblockUsers: (ids) => axios.post("/Users/UnblockUsers", { ids }),
    removeUsers: (ids) => axios.post("/Users/RemoveUsers", { ids }),
    saveUser: (user) => axios.post("/Users/SaveUser", user),
    clientAuth: () => axios.post("Users/ClientAuth", {})
};
